import { doGet, doPost } from '../../service/index';
import { call, put, takeLatest } from 'redux-saga/effects';
import { 
  UPDATE_EMAIL_SCHEDULE_REQUEST, 
  LIST_EMAIL_SCHEDULES_REQUEST,
  updateEmailScheduleSuccess,
  updateEmailScheduleFailure,
  listEmailSchedulesSuccess,
  listEmailSchedulesFailure
} from '../action/EmailSchedulerAction';
import END_POINTS from './EndPoints';
import Actions from "../action";

function* updateScheduleSaga({ params, callback }) {
  try {
    const response = yield call(doPost, END_POINTS.EMAIL_SCHEDULER_UPDATE, params);
    
    if (response?.status_code === 0) {
      yield put(updateEmailScheduleSuccess(response));
      if (callback) callback(response);
    } else {
      const error = {
        message: response?.message || 'Update failed',
        errors: response?.errors || {}
      };
      yield put(updateEmailScheduleFailure(error));
      if (callback) callback(error);
    }
  } catch (error) {
    const errorObj = {
      message: error.message || 'Network error',
      errors: error.errors || {}
    };
    yield put(updateEmailScheduleFailure(errorObj));
    if (callback) callback(errorObj);
  }
}



function* listSchedulesSaga({ params, callback }) {
  try {
    const response = yield doGet(END_POINTS.EMAIL_SCHEDULER_LIST, params);
      yield put(Actions.listEmailSchedulesSuccess(response?.response));
      if (callback) callback(response);
  } catch (error) {
    yield put(Actions.listEmailSchedulesFailure({ error }));
    if (callback) callback(error);
  }
}

export default function* watchEmailScheduleSaga() {
  yield takeLatest(UPDATE_EMAIL_SCHEDULE_REQUEST, updateScheduleSaga);
  yield takeLatest(LIST_EMAIL_SCHEDULES_REQUEST, listSchedulesSaga);
}